import React, { useEffect, useMemo } from "react";
import { Table } from "../table";
import { useStore } from "../../store/appStore";

export default function ListadoArticulo() {
  const { loadArticulos, articulosStore } = useStore();
  const data = useMemo(() => articulosStore, [articulosStore]);

  const columns = useMemo(
    () => [
      { Header: "Id", accessor: "id" },
      { Header: "Nombre", accessor: "nombre" },
      { Header: "Familia", accessor: "familia.nombre" },
      { Header: "Subfamilia", accessor: "subFamilia.nombre" },
      { Header: "Precio", accessor: d => { 
        return `${d.precioVenta.toString().replace('.', ',')} €`;
        
      } },
      { Header: "Iva", accessor: "iva.nombre" },
      { Header: "Almacen", accessor: "almacen.nombre" },
    ],
    []
  );
  useEffect(() => {
    loadArticulos();
  }, []);
  return <Table columns={columns} data={data} />;
}
